import * as Scrivito from "scrivito";

Scrivito.provideComponent("Root", ({ page }) => (
  <Scrivito.ContentTag tag="div" content={page} attribute="body" />
));
